module.exports = __webpack_public_path__ + "50a525cdc89c8be9d0ea9e20ea2c457f.pdf";